module.exports = __webpack_public_path__ + "static/index/img/password.9289b85b.png";